import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Title from '../Shared/Title';
import {
  submitSelectedEMEIConfirmation,
  closeModal,
  setSelectedIMEI,
  saveToHistory,
  errorDescriptionEnum,
  popUpEnum,
  setPopup
} from '../IMEIDeviceRepairSlice';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import FindMyIphone from '../Popups/AlertPopUp';
import {
  dwhIDFIMEISelectionPageDisplay,
  dwhIMEIPageDisplay,
  dwhIMEISelectionPageDisplay,
  dwhPrivateErrorNoRepairServiceForDevice,
  dwhPrivateErrorNoRepairServiceForUser,
  dwhPrivateIMEIPageButtonClick,
  dwhPrivateIMEIPageDisplayed
} from '../reports/dwhReports';
import Config from '../../../../Config';
import {gtag4} from '../../../../utilities/analytics/tracking';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import HelpIcon from './../images/help-icon.svg';

const IMEISelection = (props) => {
  const [showIMEIError, setShowIMEIError] = useState(false);
  const {selectedIMEI, selectedAccountOrgName} = props.deviceRepairData;
  const selectedHetPay = props.deviceRepairData.dwhData.selectedHetPay;
  const customerName = props.deviceRepairData.dwhData.customerName;
  const subscriber = props.deviceRepairData.dwhData.subscriber;
  const phone = props.deviceRepairData.selectedPhoneNumber;
  const multipleIMEIs = props.deviceRepairData?.IMEIList?.length > 1;

  useEffect(() => {
    props.saveToHistory('imei');
    if (props.isPrivate) {
      dwhIDFIMEISelectionPageDisplay({customerName, subscriber});
    } else if (props.contentData.isFromPrivateSelfcare.value) {
      dwhPrivateIMEIPageDisplayed({selectedHetPay, subscriber, customerName, selectedAccountOrgName})
    } else {
      dwhIMEISelectionPageDisplay({selectedHetPay, customerName, subscriber, phone});
    }
  }, []);

  useEffect(() => {
    if (props.deviceRepairData.errorDescription === errorDescriptionEnum.WARR_ISSUR_IND) {
      gtag4({
        event: 'DeviceRepair_ImeiErrorPage',
        action: 'ImeiErrorPage',
        error: `המכשיר לא כלול באחריות מקיפה/שירות תיקונים. יש לפנות לאחראי/ת השירות להמשך טיפול`
      });
      if (props.contentData.isFromPrivateSelfcare.value) {
        if (multipleIMEIs) {
          dwhPrivateErrorNoRepairServiceForDevice({selectedHetPay, subscriber, selectedIMEI, customerName, selectedAccountOrgName})
        } else {
          dwhPrivateErrorNoRepairServiceForUser({selectedHetPay, subscriber, selectedIMEI, customerName, selectedAccountOrgName})
        }
      }
    }
  }, [props.deviceRepairData.errorDescription]);

  const selectBoxObj = [];

  props.deviceRepairData.IMEIList.map((imei) => {
    selectBoxObj.push({key: `IMEI ${imei}`, value: imei});
  });

  const handleSelectIMEI = (e) => {
    props.setSelectedIMEI(e);
  };

  const submitSelectedEMEIConfirmation = () => {
    if (!selectedIMEI) {
      setShowIMEIError(true);
      return;
    }
    setShowIMEIError(false);
    let sendingData = {
      orgId: props.portalState.selectedHetPayId,
      startPoint: props.deviceRepairData.startPoint,
      selectedNumber: !props.loginData?.userDetails?.IsContactPerson ? props.loginData?.userDetails?.contactNumber : props.deviceRepairData.selectedPhoneNumber,
      selectedIMEI: props.deviceRepairData.selectedIMEI,
      isPrivate: props.deviceRepairData?.isPrivate,
      isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value == true
    };
    props.saveToHistory();
    props.submitSelectedEMEIConfirmation(sendingData);
  };

  const getBtnAction = () => {
    if (props.contentData.isFromPrivateSelfcare.value) {
      dwhPrivateIMEIPageButtonClick({selectedHetPay, subscriber, selectedIMEI, customerName, selectedAccountOrgName})
    }
    if (props.deviceRepairData.errorDescription == errorDescriptionEnum.WARR_ISSUR_IND) {
      return goToBusinessSelfcare();
    }
    return submitSelectedEMEIConfirmation();
  };

  const goToBusinessSelfcare = async () => {
    const content = await props.context.loadContentByPath(Config.businessLobbyUrl);
    props.context.navigateTo(content);
  };

  const getBtnText = () => {
    if (props.deviceRepairData.errorDescription === errorDescriptionEnum.WARR_ISSUR_IND) {
      return 'חזרה לאזור האישי';
    }
    return 'המשך';
  };


  return (
    <div className="imei-selection-wrapper">
      <Title text={'תאום שליחות לתיקון מכשיר'}
             subtext={multipleIMEIs ? 'מה המספר סידורי עליו תבוצע השליחות?' : 'המספר סידורי עליו תבוצע השליחות'} />
      <div className="imei-selection-form">
        {multipleIMEIs ? <SelectList options={selectBoxObj} onClick={(e) => handleSelectIMEI(e)} /> :
          <div className={'imei-card'}>
            <div className={'imei-card-title'}>מספר IMEI</div>
            <div className={'imei-number'}>IMEI {props.deviceRepairData.IMEIList[0]}</div>
          </div>}
        <div className={'help-text-container'}>
          <span className={'help-text'}>איפה מוצאים את המספר הסידורי?</span>
          <div onClick={() => props.setPopup(popUpEnum.IMEI_HELP)}>
            <Image className={'help-icon'} src={HelpIcon} alt={'help'} />
          </div>
        </div>

      </div>
      <div className="imei-select-submit">
        {showIMEIError && <span className={'cellcom-color'}>אנא בחר מספר IMEI</span>}
        <BtnSubmit text={getBtnText()} onclick={() => getBtnAction()} />
      </div>

      <PopUp className={'imei-device-repair-popup'} showPopUp={props.deviceRepairData.isShowPopup}
             onClose={() => props.closeModal()}>
        <FindMyIphone />
      </PopUp>
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
    deviceRepairData: state.iMEIDeviceRepair,
    portalState: state.portalsBlock,
    loginData: state.authentication.loginData
  };
};

const mapDispatchToProps = {submitSelectedEMEIConfirmation, closeModal, setSelectedIMEI, saveToHistory, setPopup};

export default connect(mapStateToProps, mapDispatchToProps)(IMEISelection);
